import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  UPDATE_FIELD_AUTH,
  LOGIN,
  LOGIN_PAGE_UNLOADED
} from '../constants/actionTypes';
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import PasswordInput from "./Core/PasswordInput/PasswordInput";
import styles from "./Login.module.css";

const mapStateToProps = state => ({ 
  ...state.auth, 
  errors: state.error.messages, 
  currentUser: state.common.currentUser 
});

const mapDispatchToProps = dispatch => ({
  onChangeEmail: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'email', value }),
  onChangePassword: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'password', value }),
  onSubmit: (email, password) =>
    dispatch({ type: LOGIN, payload: agent.Auth.login(email, password) }),
  onUnload: () =>
    dispatch({ type: LOGIN_PAGE_UNLOADED }),
});

class Login extends React.Component {
  constructor() {
    super();
    this.changeEmail = ev => this.props.onChangeEmail(ev.target.value);
    this.changePassword = ev => this.props.onChangePassword(ev.target.value);
    this.submitForm = (email, password) => ev => {
      ev.preventDefault();
      this.props.onSubmit(email, password);
    };
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    const email = this.props.email||'';
    const password = this.props.password||'';

    if (!this.props.currentUser) {
      return (
        <div className={styles.page}>
          <div className={styles.glowOne} />
          <div className={styles.glowTwo} />

          <div className={styles.layout}>
            <aside className={styles.brandPanel}>
              <h1>Управляйте доставкой из одного центра</h1>
              <p className={styles.brandSubtitle}>
                Заказы, маршруты, тарифы, мониторинг и интеграции собраны в единой рабочей среде.
              </p>
              <ul className={styles.featureList}>
                <li>
                  <i className="pi pi-chart-line" />
                  Контроль статусов в реальном времени
                </li>
                <li>
                  <i className="pi pi-map" />
                  Точечное управление направлениями и терминалами
                </li>
                <li>
                  <i className="pi pi-calculator" />
                  Быстрый расчет тарифов и плеч доставки
                </li>
              </ul>
            </aside>

            <section className={styles.formPanel}>
              <div className={styles.formCard}>
                <h2>Вход в кабинет</h2>
                <p className={styles.formHint}>Введите email и пароль для продолжения</p>

                <ListErrors errors={this.props.errors} />

                <form onSubmit={this.submitForm(email, password)} className={styles.form}>
                  <label className={styles.field}>
                    <span>Email</span>
                    <InputText
                      name="username"
                      type="text"
                      placeholder="you@company.com"
                      value={email}
                      onChange={this.changeEmail}
                      className={styles.input}
                    />
                  </label>

                  <label className={styles.field}>
                    <span>Пароль</span>
                    <PasswordInput
                      name="password"
                      placeholder="Введите пароль"
                      value={password}
                      onChange={this.changePassword}
                      inputClassName={styles.input}
                      autoComplete="current-password"
                    />
                  </label>

                  <Button
                    type="submit"
                    label={this.props.inProgress ? "Входим..." : "Войти"}
                    className={styles.submitButton}
                    disabled={this.props.inProgress}
                  />
                </form>


              </div>
            </section>
          </div>
        </div>
      );
    } else {
      return null
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
